var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function setElementBaseProps(props, reducedProps) {
    if (props.elementProps)
        reducedProps.props = __assign(__assign({}, reducedProps.props), props.elementProps);
    if (props.id)
        reducedProps.props.id = props.id;
    if (props.tabIndex)
        reducedProps.props.tabIndex = props.tabIndex;
    if (props.className)
        reducedProps.classes = "".concat(reducedProps.classes, " ").concat(props.className);
    if (props.style)
        reducedProps.styles = __assign(__assign({}, reducedProps.styles), props.style);
}
